import { useContext } from 'react'
import { Link } from 'react-router-dom'
import { SidebarContext } from '../../../shared/contexts/SidebarContext'
import { subscribersPath } from '../../../logic/paths'
import SidebarMenu from './SidebarMenu'
import PieceWorkProLogo from '../../../assets/images/pieceWorkProLogo.png'
import NhrIcon from '../../../assets/images/nhr.png'
import { SidebarContainer, MobileSidebarContainer, SidebarOverlay, LogoArea, SidebarDivider } from './Sidebar.styled'

function Sidebar() {
  const { sidebarToggle, closeSidebar, isCollapsed } = useContext(SidebarContext)

  return (
    <>
      {/* Desktop Sidebar */}
      <SidebarContainer $isCollapsed={isCollapsed}>
        <LogoArea $isCollapsed={isCollapsed}>
          <Link to={subscribersPath}>
            <img src={PieceWorkProLogo} alt="PieceWorkPro" className={isCollapsed ? 'collapsed-logo' : ''} />
          </Link>
        </LogoArea>
        <SidebarDivider />
        <SidebarMenu isCollapsed={isCollapsed} />
      </SidebarContainer>

      {/* Mobile Sidebar Overlay */}
      {sidebarToggle && (
        <>
          <SidebarOverlay onClick={closeSidebar} />
          <MobileSidebarContainer>
            <LogoArea>
              <Link to={subscribersPath}>
                <img src={PieceWorkProLogo} alt="PieceWorkPro" />
              </Link>
            </LogoArea>
            <SidebarDivider />
            <SidebarMenu isCollapsed={false} />
          </MobileSidebarContainer>
        </>
      )}
    </>
  )
}

export default Sidebar
